export const PROJECT_ENDPOINTS = {
  GET_PROJECT: '/project/',
  GET_PROJECT_COST_CENTRES: 'v1.1/project_drop_down_cost_centres/',
  GET_PROJECT_SETTINGS: '/v1.2/project-setting/',
  GET_PROJECT_SEGMENTS: '/v1.1/project_drop_down_segments/',
  GET_PROJECT_STATES: '/v1.1/project_drop_down_states/',
  GET_PROJECT_CLIENTS: '/v1.1/project_drop_down_clients/',
  GET_PROJECT_DRAFTS: '/project/drafts/',
  ARCHIVE_PROJECT: '/project/',
  ARCHIVE_PROJECT_LIST: '/project/',
  DELETE_PROJECT: '/feature_delete/',
  DELETE_DRAFT_PROJECT: (projectId: string) =>
    `/project/${projectId}/draft_delete/`,
  GET_PROJECT_DROPDOWN: '/v1.1/api-bills/dropdown/projects/',
  /**
   * Unified project dropdown (expects params: page, per_page, source, optional q).
   * Base URL already includes `/api/v1` via the Axios singleton.
   */
  GET_PROJECT_DROPDOWN_V2: '/v1.1/project/dropdown/',
  XERO_TRACKING_DROPDOWN: '/integration/xero_tracking_category/',
  SYNC_TRACKING_CATEGORIES: '/integration/sync_tracking_categories/',
  GET_BULK_PROJECT_SETTINGS: '/v1.2/bulk-project-setting/',
  GET_SUB_SEGMENTS: '/v1.1/project_drop_down_sub_segments/',
  CREATE_CLIENT: '/v1.1/client/create/',
  SAVE_DRAFT_PROJECT: 'project/draft/',
  RESOURCE_COST_LIST: '/v1.1/project_drop_down_resource_code_list/',
  PAYMENT_ACT_LIST: '/v1.1/project_drop_down_claim_payment_act/',
  ALLOWANCE_LIST: 'v1.1/allowance/',
  VALIDATE_ESTIMATION_SHEET: 'project/validate_estimation_sheet/',
  PROJECT_DETAIL: (id: string) => `/project/${id}/`,
  DRAFT_PROJECT_DETAIL: (id: string) => `/project/${id}/draft_detail/`,
  CHANGE_PROJECT_STATUS: (id: string) => `project/change_project_status/${id}/`,
};
export const PROJECT_IMPORT_ENDPOINTS = {
  VALIDATE_PROJECT_SHEET: 'v1.1/ai/digital-project/import-validation/',
  UPLOAD_PROJECT_SHEET: 'v1.1/ai/digital-project/import/',
  CHAT: 'https://ai.varicontest.com.au/project_validation/chat',
  CREATE_UPDATE_CLIENTS: 'v1.1/client/bulk_upsert/',
  GET_USERS_BY_ROLE: 'user/get-user-by-role/',
  REGISTER_STAFF: 'user/register_staff',
  GET_ROLES_LIST: 'roles/list',
} as const;

export const PROJECT_DRAFT_ENDPOINTS = {
  SAVE_DRAFT: 'v1.1/draft_document/',
  GET_DRAFT: 'v1.1/draft_document/retrieve/',
  DELETE_DRAFT: `v1.1/draft_document/destroy/`,
} as const;
